module.exports = __webpack_public_path__ + "img/os.ec75a4c2.png";